import MoreOptions from "@assets/more-options.svg";
import { css } from "@emotion/react";
import { formatDistanceToNow } from "date-fns";
import { useState } from "react";
import { useNavigate } from "react-router";
import { theme } from "../../../design/theme";
import { IconButton } from "../buttons";
import { FlexColContainer } from "../layout";
import { BookmarkCollectionNotebookImage } from "./BookmarkCollectionNotebookImage";
import { CreateOrEditCollectionModal } from "./CreateOrEditCollectionModal";

interface CollectionListItemProps {
  collection: {
    id: number;
    name: string;
    colour: string;
    lastModified: string;
  };
  colour: string;
}

export const CollectionListItem = ({
  collection,
  colour,
}: CollectionListItemProps) => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <FlexColContainer>
      <div
        css={css`
          position: relative;
        `}
      >
        <button
          css={css`
            border: none;
            background: none;
            padding: 0;
          `}
          onClick={() => navigate(`/collections/${collection.id}`)}
        >
          <BookmarkCollectionNotebookImage
            collectionName={collection.name}
            colour={colour}
          />
        </button>
        <CreateOrEditCollectionModal
          isOpen={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          isEdit
          collection={collection}
          renderButton={() => (
            <IconButton
              css={css`
                background: none;
                border: none;
                box-shadow: none;
                color: #000;
                padding: 0;
                position: absolute;
                bottom: -4px;
                right: 24px;
              `}
              onClick={() => setIsEditOpen(true)}
              src={MoreOptions}
              alt="Edit Collection"
            />
          )}
        />
      </div>
      <FlexColContainer
        css={css`
          margin-top: 8px;
          max-width: 208px;
          text-align: center;
        `}
      >
        <span
          css={css`
            overflow-wrap: break-word;
            word-break: break-word;
          `}
        >
          {collection.name}
        </span>
        <span
          css={css`
            color: ${theme.colours.primary.mid.light20};
            font-size: 12px;
            margin-top: 4px;
          `}
        >
          Updated {formatDistanceToNow(new Date(collection.lastModified), {})}{" "}
          ago
        </span>
      </FlexColContainer>
    </FlexColContainer>
  );
};
